import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../context/LanguageContext';

function VideoSection() {
    const { isEnLang } = useLanguage();
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

    const T = isEnLang ? {
        label: 'Video',
        title: 'Discover Alma Suite',
        sub: 'A preview of what awaits you at our B&B between Anzio and Nettuno.',
    } : {
        label: 'Video',
        title: 'Scopri l\'Alma Suite',
        sub: 'Un\'anteprima di ciò che ti aspetta al nostro B&B tra Anzio e Nettuno.',
    };

    return (
        <section className="video-section">
            <motion.div
                ref={ref}
                className="video-section-inner l-1260"
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8 }}
            >
                <div className="video-section-text">
                    <span className="section-label">{T.label}</span>
                    <h2>{T.title}</h2>
                    <p>{T.sub}</p>
                </div>
                <div className="video-grid">
                    <video controls muted playsInline preload="metadata">
                        <source src={`${process.env.PUBLIC_URL}/videos/suite-jacuzzi-1.mp4`} type="video/mp4" />
                    </video>
                    <video controls muted playsInline preload="metadata">
                        <source src={`${process.env.PUBLIC_URL}/videos/suite-jacuzzi-2.mp4`} type="video/mp4" />
                    </video>
                </div>
            </motion.div>
        </section>
    );
}

export default VideoSection;
